<div class="text-center mt-10 text-gray-600">
  Validating your invitation, please wait...
</div>
